export const LOGO_URL = "https://nmcregistered.org.uk/uploads/assets/logo.png"
export const BACKGROUND_IMG = "https://nmcregistered.org.uk/uploads/assets/background.jpg"